__turbopack_context__.v({
  "className": "sans_484bcff9-module__YH45oW__className",
  "variable": "sans_484bcff9-module__YH45oW__variable",
});
